import {
    FaEye,
    FaPaperPlane,
    FaTrash,
    FaEdit,
} from "react-icons/fa";

import "../../styles/NotificationTable.css";

const NotificationTable = ({
    notifications = [],
    loading = false,
    onView,
    onEdit,
    onDelete,
    onSend,
}) => {

    const getStatusClass = (status) => {
        switch (status) {
            case "sent":
                return "status sent";
            case "scheduled":
                return "status scheduled";
            case "draft":
                return "status draft";
            case "failed":
                return "status failed";
            default:
                return "status";
        }
    };

    const getAudienceClass = (audience) => {
        switch (audience) {
            case "customers":
                return "audience customers";
            case "providers":
                return "audience providers";
            case "deliveryPartners":
                return "audience delivery";
            default:
                return "audience all";
        }
    };

    const getTypeClass = (type) => {
        switch (type) {
            case "offer":
                return "type offer";
            case "announcement":
                return "type announcement";
            case "order":
                return "type order";
            case "payment":
                return "type payment";
            case "account":
                return "type account";
            default:
                return "type general";
        }
    };

    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    if (!notifications.length) {
        return (
            <div className="notification-empty">
                <h3>No Notifications Found</h3>
                <p>
                    Create your first notification to communicate
                    with your users.
                </p>
            </div>
        );
    }

    return (
        <div className="notification-table-wrapper">

            <table className="notification-table">

                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Audience</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Created</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>

                    {notifications.map((item) => (

                        <tr key={item._id}>

                            <td>

                                <div className="notification-title">

                                    <strong>
                                        {item.title || "-"}
                                    </strong>

                                    <small>
                                        {(item.message || "").length > 60
                                            ? `${item.message.substring(
                                                  0,
                                                  60
                                              )}...`
                                            : item.message || "-"}
                                    </small>

                                </div>

                            </td>

                            <td>

                                <span
                                    className={getAudienceClass(
                                        item.audience
                                    )}
                                >
                                    {item.audience || "All"}
                                </span>

                            </td>

                            <td>

                                <span
                                    className={getTypeClass(
                                        item.type
                                    )}
                                >
                                    {item.type || "general"}
                                </span>

                            </td>

                            <td>

                                <span
                                    className={getStatusClass(
                                        item.status
                                    )}
                                >
                                    {item.status || "-"}
                                </span>

                            </td>

                            <td>
                                {formatDate(item.createdAt)}
                            </td>

                            <td>

                                <div className="notification-actions">

                                    <button
                                        className="view-btn"
                                        title="View Notification"
                                        disabled={loading}
                                        onClick={() =>
                                            onView?.(item._id)
                                        }
                                    >
                                        <FaEye />
                                    </button>

                                    <button
                                        className="edit-btn"
                                        title="Edit Notification"
                                        disabled={loading}
                                        onClick={() =>
                                            onEdit?.(item._id)
                                        }
                                    >
                                        <FaEdit />
                                    </button>

                                    {item.status !== "sent" &&
                                        item.status !== "failed" && (
                                            <button
                                                className="send-btn"
                                                title="Send Notification"
                                                disabled={loading}
                                                onClick={() =>
                                                    onSend?.(
                                                        item._id
                                                    )
                                                }
                                            >
                                                <FaPaperPlane />
                                            </button>
                                        )}

                                    <button
                                        className="delete-btn"
                                        title="Delete Notification"
                                        disabled={loading}
                                        onClick={() =>
                                            onDelete?.(
                                                item._id
                                            )
                                        }
                                    >
                                        <FaTrash />
                                    </button>

                                </div>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>
    );
};

export default NotificationTable;